import { createConfigLoader } from "@/config";
import aelIcon from "@/icons/countries/ae.svg";
import espIcon from "@/icons/countries/es.svg";
import frlIcon from "@/icons/countries/fr.svg";
import geIcon from "@/icons/countries/ge.svg";
import grIcon from "@/icons/countries/gr.svg";
import uaIcon from "@/icons/countries/ua.svg";
import { ICountryValue } from "@/types/country.types";

// Interface for country configuration
export interface ICountryConfig {
  countries: ICountryValue[];
}

// Default country configuration
export const defaultCountryConfig: ICountryConfig = {
  countries: [
    {
      label: "Greece",
      value: "Greece",
      icon: grIcon,
      code: "GR",
      link: "https://avezor.gr/",
    },
    {
      label: "Ukraine",
      value: "Ukraine",
      icon: uaIcon,
      code: "UA",
      link: "https://avezor.ua/",
    },
    {
      label: "Spain",
      value: "Spain",
      icon: espIcon,
      code: "ES",
      link: "https://avezor.es/",
    },
    {
      label: "Georgia",
      value: "Georgia",
      icon: geIcon,
      code: "GE",
      link: "https://avezor.ge/",
    },
    {
      label: "France",
      value: "France",
      icon: frlIcon,
      code: "FR",
      link: "https://avezor.fr/",
    },
    {
      label: "UAE",
      value: "Dubai",
      icon: aelIcon,
      code: "AE",
      link: "https://avezor.ae/",
    },
  ],
};

// Load configuration with country-specific overrides
const countryConfigData = createConfigLoader(defaultCountryConfig, "country");

// Export processed configuration
export const countryConfig = new Map<string, ICountryValue>();
export const countries: ICountryValue[] = countryConfigData.countries;

// Initialize map
countryConfigData.countries.forEach((country) => {
  countryConfig.set(country.value.toLowerCase(), country);
});

// Export getter functions for compatibility
export const getCountryConfig = (): ICountryConfig => countryConfigData;
export const getCountries = (): ICountryValue[] => countries;
export const getCountryConfigMap = (): Map<string, ICountryValue> =>
  countryConfig;
